export default __webpack_public_path__ + "static/mid3b-48e03a3121518db8b76f3bc1f8680b77.png";